import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';
import { CommonService } from '../../../../app/services/common.service';
import { FileuploadService } from '../../../../app/services/fileupload.service';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-vendor-registration',
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.css']
})
export class VendorRegistrationComponent extends BaseComponent implements OnInit {
  myForm!: UntypedFormGroup;
  savedData: any = localStorage.getItem('');
  formData: FormData = new FormData();
  fileInput: any = '';
  file: File;
  currencyList: Array<any> = [];
  editData: any;
  isUrlBasedLogo: boolean = false;
  vendorCategoryList: Array<any> = [];
  vendorTypeList: Array<any> = [];
  dropdownVendorTypeSettings: any = {};
  selectedVendorType: { vendor_type_id: number; vendor_type_name: string; }[];
  itemGroupList: Array<any> = [];
  dropdownItemGroupSettings: any = {};
  selectedItemGroup: { id: number; name: string; }[];

  // store actual files
  uploadedFiles: { [key: string]: File | null } = {};

  // store uploaded file paths (for view)
  uploadedFilePaths: { [key: string]: string } = {};
  complianceDocs = [
    { key: 'document_path', label: 'Certificate of Incorporation / Registration', required: false },
    { key: 'partnership_deed_path', label: 'CR12 / Partnership Deed', required: false },
    { key: 'kra_path', label: 'KRA PIN Certificate', required: true },
    { key: 'tax_path', label: 'Tax Compliance Certificate', required: true },
    { key: 'vat_path', label: 'VAT Certificate', required: false },
    { key: 'permit_path', label: 'Business Permit / Trade License', required: true },
    { key: 'nca_path', label: 'NCA Certificate (for works)', required: false },
    { key: 'prof_licenses_path', label: 'Professional Licenses', required: false },
    { key: 'agpo_path', label: 'AGPO / Special Group Certificates', required: false }
  ];
  countryList: any;
  countyList: any;
  constructor(public formBuilder: UntypedFormBuilder, toastr: ToastrService, private route: Router, CommonService: CommonService, private fileuploadService: FileuploadService) {
    super(CommonService, toastr);
    this.checkUrlLogo(location.href);
  }


  ngOnInit(): void {
    this.formInIt();
    this.loadData(); this.loadAllDropdowns();
    this.dropdownVendorTypeSettings = {
      singleSelection: false,
      idField: 'vendor_type_id',
      textField: 'vendor_type_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownItemGroupSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.complianceDocs.forEach(d => {
      this.uploadedFiles[d.key] = null;
      this.uploadedFilePaths[d.key] = '';
    });
  }

  onSelectAll(event: any) { }
  onSelectOne(event: any) { }

  checkUrlLogo(url: string) {
    const urlObj = { dhanushFinance: 'https://finance.dhanushinfotech.com/login', financeDemo: 'https://financedemo.dhanushinfotech.com/login', nwhQa: "https://nwhfinanceqa.dhanushinfotech.com/login", nwhPreprod: "https://nwhfinancepreprod.dhanushinfotech.com/login", nwhProd: "https://finance.himscmchbhopal.com/login" };
    const { nwhQa, nwhPreprod, nwhProd, dhanushFinance, financeDemo } = urlObj;
    if (dhanushFinance === url || financeDemo === url || nwhQa === url || nwhPreprod === url || nwhProd === url) {
      this.isUrlBasedLogo = true;
      localStorage.setItem('isUrlBasedLogo', 'true');
    } else {
      this.isUrlBasedLogo = false;
      localStorage.setItem('isUrlBasedLogo', 'false');
    }
  }


  formInIt() {
    this.myForm = this.formBuilder.group({
      organizationName: [''],
      emailId: [atob(localStorage.getItem('Email'))],
      mobileNo: [atob(localStorage.getItem('mNo'))],
      first_name: [''],
      last_name: [''],
      // org_address: ['', Validators.required],
      vendor_code: ['', Validators.required],
      org_reg_no: ['', Validators.required],
      kra_no: ['', Validators.required],
      // upload_proof: ['', Validators.required],
      bank_name: [''],
      account_no: [''],
      branch: [''],
      bank_code: [''],
      vreg_currency_id: [3, Validators.required],
      vreg_vendor_type_id: ['', Validators.required],
      vreg_business_id: ['', Validators.required],

      vreg_country_id: ['0'],
      county_id: ['0'],
      town_name: [''],
      vreg_address: [''],
      postal_code: [''],
      street_name: [''],
      vreg_email: [''],
      vreg_mobile: [''],

      vreg_con_firstname: [localStorage.getItem('Username'), Validators.required],
      vreg_con_lastname: ['', Validators.required],
      vreg_con_emailId: [atob(localStorage.getItem('Email')), Validators.required],
      vreg_con_mobileNo: [atob(localStorage.getItem('mNo')), Validators.required],
      vreg_account_no: [''],
      account_name: [''],

      document_path: [''],
      partnership_deed_path: [''],
      kra_path: ['', Validators.required],
      tax_path: ['', Validators.required],
      vat_path: [''],
      permit_path: ['', Validators.required],
      nca_path: [''],
      prof_licenses_path: [''],
      agpo_path: [''],
      vreg_trading_name: [''],

      vreg_agpo_no: [''],
      // vreg_group_ids: ['', Validators.required],
      vreg_ifmis_no: ['', Validators.required],
    });
  }

  loadData() {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(`FinanceVendor/GetVendorRegistrationById/${localStorage.TenantCode}/${localStorage.UserId}`).subscribe((res: any) => {
      console.log(res);
      if (res.data === null) {
        // this.loadParameters();
        const date = new Date();
        const formatted = `VED-${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}-${Math.floor(Math.random() * 1000)}`;
        this.myForm.patchValue({
          vendor_code: formatted
        });
      } else {
        this.editData = res.data;
        this.fileInput = this.editData.vreg_document_path
        this.myForm.patchValue({
          organizationName: this.editData.vreg_name,
          emailId: this.editData.vreg_email,
          vreg_email: this.editData.vreg_email,
          vreg_con_emailId: this.editData.vreg_email,
          mobileNo: this.editData.vreg_mobile,
          vreg_con_mobileNo: this.editData.vreg_mobile,
          vreg_mobile: this.editData.vreg_mobile,
          vreg_con_firstname: this.editData.vreg_first_name,
          vreg_con_lastname: this.editData.vreg_last_name,
          org_address: this.editData.vreg_address,
          vendor_code: this.editData.vreg_code,
          org_reg_no: this.editData.vreg_Registration_no,
          kra_no: this.editData.vreg_kra_no,
          // upload_proof: this.editData.vreg_document_path,
          bank_name: this.editData.bank_name,
          account_no: this.editData.vreg_account_no,
          branch: this.editData.branch,
          vreg_currency_id: this.editData.vreg_currency_id,
          vreg_vendor_type_id: this.editData.vreg_vendor_type_id,
          vreg_agpo_no: this.editData.vreg_agpo_no,
          vreg_group_ids: this.editData.vreg_group_ids,
          vreg_ifmis_no: this.editData.vreg_ifmis_no,
          vreg_con_emailIdId: this.editData.vreg_con_emailIdId,
        })
      }
      this.CommonService.deactivateSpinner();
    }, e => { this.CommonService.deactivateSpinner(); })
  }

  loadParameters() {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(`Parameter/GetList/${localStorage.TenantCode}/${11}`).subscribe((res: any) => {
      let sequence_id = res.data.find((e: any) => e.par_parametername_id == 16)?.par_squence_id;
      if (sequence_id == undefined) {
        this.toastr.warning('Vendor Code is not assigned');
      } else {
        this.bindPurchaseOrder(sequence_id);
      }
      this.CommonService.deactivateSpinner();
    }, e => { this.CommonService.deactivateSpinner(); })

  }

  loadAllDropdowns() {
    this.CommonService.activateSpinner();
    const tntCode = +localStorage.TenantCode;
    // const currencyPayload = { DictionaryCode: '465154cd' };
    // const currency$ = this.CommonService.postCall('DataDictionary/GetDictionaryByKey', currencyPayload);
    const currency$ = this.CommonService.getCall(`Currency/GetList/${tntCode}/1`);
    const vendorCategories$ = this.CommonService.getCall(`FinanceVendor/VendorcategoryGetByActive/${tntCode}/1`);
    const vendorType$ = this.CommonService.getCall(`BidTenderCreation/GetVendorTypeList/${tntCode}`);
    const itemGroup$ = this.CommonService.getCall(`PurchaseOrders/GetProcurementItemGroups/${tntCode}/true`);
    const country$ = this.CommonService.getCall(`FinanceCountry/GetList/${this.TenantCode}`);
    const county$ = this.CommonService.getCall('County/GetList/0');
    forkJoin([currency$, vendorCategories$, vendorType$, itemGroup$, country$, county$]).subscribe(
      ([currencyRes, vendorCategoryRes, vendorTypeRes, itemGroupRes, countryRes, countyRes]: any[]) => {
        this.currencyList = currencyRes.data;
        this.vendorCategoryList = vendorCategoryRes.data;
        this.vendorTypeList = vendorTypeRes.data;
        this.vendorTypeList = vendorTypeRes.data;
        this.itemGroupList = itemGroupRes.data.map(e => ({ ...e, id: e.itemgroup_id, name: `${e.ig_itemgroup} - ${e.ig_name}` }));
        this.countryList = countryRes.data;
        this.countyList = countyRes.data;
        this.CommonService.deactivateSpinner();
      },
      error => {
        console.error('Error loading dropdowns:', error);
        this.CommonService.deactivateSpinner();
      }
    );
  }

  bindPurchaseOrder(sId: any) {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(`SequenceNumber/GetSequenceNumber/${localStorage.TenantCode}/${sId}`).subscribe((res: any) => {
      if (res.data.length) {
        this.myForm.patchValue({ vendor_code: res.data[0].seqnumber })
      } else {
        this.toastr.info('Vendor Code is not genarted', 'Please try again')
      }
      this.CommonService.deactivateSpinner();
    }, e => { this.CommonService.deactivateSpinner(); })
  }

  onFileChange(event: any) {
    this.CommonService.activateSpinner();
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      if (this.file.type !== 'application/pdf') {
        this.toastr.warning('Only PDF files are allowed!');
        event.target.value = '';
        this.CommonService.deactivateSpinner();
        return;
      }
      // this.myForm.patchValue({ upload_proof: this.file.name })
    }
    this.CommonService.deactivateSpinner();
  }

  private createFormDataOld(): FormData {
    let data = this.myForm.getRawValue();
    const formData = new FormData();
    formData.append('vreg_name', data.organizationName);
    formData.append('vreg_email', data.emailId);
    formData.append('vreg_mobile', data.mobileNo);
    formData.append('vreg_first_name', data.vreg_con_firstname);
    formData.append('vreg_last_name', data.vreg_con_lastname);
    formData.append('vreg_address', data.org_address);
    formData.append('vreg_code', data.vendor_code);
    formData.append('vreg_Registration_no', data.org_reg_no);
    formData.append('vreg_kra_no', data.kra_no);
    formData.append('vreg_document_path', this.file);
    formData.append('bank_name', data.bank_name);
    formData.append('vreg_account_no', data.account_no);
    formData.append('vreg_branch', data.branch);
    formData.append('status', 'false');
    formData.append('created_by', localStorage.UserId);
    formData.append('tnt_code', localStorage.TenantCode);
    formData.append('modified_by', localStorage.UserId);
    formData.append('vreg_user_id', localStorage.UserId);
    formData.append('vreg_currency_id', data.vreg_currency_id);
    formData.append('vreg_vendor_type_id', this.selectedVendorType?.map((i: any) => i.vendor_type_id).join(',') || '');

    formData.append('vreg_agpo_no', data.vreg_agpo_no);
    // formData.append('vreg_group_ids', this.selectedItemGroup?.map((e: any) => e.id).join(',') || '');
    formData.append('vreg_ifmis_no', data.vreg_ifmis_no);
    formData.append('vreg_con_emailIdId', data.vreg_con_emailIdId);
    formData.append('vreg_con_mobileNo', data.vreg_con_mobileNo);
    formData.append('vreg_con_firstname', data.vreg_con_firstname);
    formData.append('vreg_con_lastname', data.vreg_con_lastname);
    formData.append('url', location.origin.includes("localhost") ? "https://oukdev.samvaadpro.com/vendorlogin" : location.origin + '/vendorlogin');
    // formData.append('registration_id', this.editData.registration_id || 0);
    return formData;
  }

  private createFormData(): FormData {

    const data = this.myForm.getRawValue();
    const formData = new FormData();

    /* ============================
       OLD KEYS (UNCHANGED)
       ============================ */
    formData.append('vreg_name', data.organizationName || '');
    formData.append('vreg_email', data.emailId || '');
    formData.append('vreg_mobile', data.mobileNo || '');
    formData.append('vreg_first_name', data.vreg_con_firstname || '');
    formData.append('vreg_last_name', data.vreg_con_lastname || '');
    formData.append('vreg_address', data.org_address || '');
    formData.append('vreg_code', data.vendor_code || '');
    formData.append('vreg_Registration_no', data.org_reg_no || '');
    formData.append('vreg_kra_no', data.kra_no || '');

    // OLD single document (keep for backward compatibility)
    if (this.file) {
      formData.append('vreg_document_path', this.file);
    }

    formData.append('bank_name', data.bank_name || '');
    formData.append('vreg_account_no', data.account_no || '');
    formData.append('vreg_branch', data.branch || '');
    formData.append('status', 'false');
    formData.append('created_by', localStorage.UserId);
    formData.append('modified_by', localStorage.UserId);
    formData.append('vreg_user_id', localStorage.UserId);
    formData.append('tnt_code', localStorage.TenantCode);
    formData.append('vreg_currency_id', data.vreg_currency_id || '');

    formData.append(
      'vreg_vendor_type_id',
      this.selectedVendorType?.map((i: any) => i.vendor_type_id).join(',') || ''
    );

    formData.append('vreg_agpo_no', data.vreg_agpo_no || '');
    formData.append(
      'vreg_group_ids',
      this.selectedItemGroup?.map((e: any) => e.id).join(',') || ''
    );
    formData.append('vreg_ifmis_no', data.vreg_ifmis_no || '');
    formData.append('vreg_con_emailIdId', data.vreg_con_emailIdId || '');
    formData.append('vreg_con_mobileNo', data.vreg_con_mobileNo || '');
    formData.append('vreg_con_firstname', data.vreg_con_firstname || '');
    formData.append('vreg_con_lastname', data.vreg_con_lastname || '');

    formData.append(
      'url',
      location.origin.includes('localhost')
        ? 'https://oukdev.samvaadpro.com/vendorlogin'
        : location.origin + '/vendorlogin'
    );

    /* ============================
       NEW KEYS (ADDED SAFELY)
       ============================ */

    /* Vendor Basic Details */
    formData.append('vreg_trading_name', data.organizationName || '');
    formData.append('vreg_business_id', data.vreg_business_id || '');

    /* Statutory Compliance Documents */
    if (this.uploadedFiles?.document_path) {
      formData.append('document_path', this.uploadedFiles.document_path);
    }

    if (this.uploadedFiles?.partnership_deed_path) {
      formData.append('partnership_deed_path', this.uploadedFiles.partnership_deed_path);
    }

    if (this.uploadedFiles?.kra_path) {
      formData.append('kra_path', this.uploadedFiles.kra_path);
    }

    if (this.uploadedFiles?.tax_path) {
      formData.append('tax_path', this.uploadedFiles.tax_path);
    }

    if (this.uploadedFiles?.vat_path) {
      formData.append('vat_path', this.uploadedFiles.vat_path);
    }

    if (this.uploadedFiles?.permit_path) {
      formData.append('permit_path', this.uploadedFiles.permit_path);
    }

    if (this.uploadedFiles?.nca_path) {
      formData.append('nca_path', this.uploadedFiles.nca_path);
    }

    if (this.uploadedFiles?.prof_licenses_path) {
      formData.append('prof_licenses_path', this.uploadedFiles.prof_licenses_path);
    }

    if (this.uploadedFiles?.agpo_path) {
      formData.append('agpo_path', this.uploadedFiles.agpo_path);
    }

    /* Physical & Postal Address */
    formData.append('vreg_country_id', data.vreg_country_id || '');
    formData.append('county_id', data.county_id || '');
    formData.append('town_name', data.town_name || '');
    formData.append('postal_code', data.postal_code || '');
    formData.append('street_name', data.street_name || '');
    formData.append('vreg_email', data.vreg_email || '');
    formData.append('vreg_mobile', data.vreg_mobile || '');

    /* Authorized Contact Person */
    formData.append('vreg_con_firstname', data.vreg_con_firstname || '');
    formData.append('vreg_con_lastname', data.vreg_con_lastname || '');
    formData.append('vreg_con_emailId', data.vreg_con_emailId || '');
    formData.append('vreg_con_mobileNo', data.vreg_con_mobileNo || '');

    /* Banking Details */
    formData.append('vreg_account_no', data.vreg_account_no || '');
    formData.append('account_name', data.account_name || '');
    formData.append('bank_name', data.bank_name || '');

    return formData;
  }


  submit(form: any) {
    this.activeSpinner();
    const formData = this.createFormData();
    console.log(formData);
    this.fileuploadService.upload(formData, 'FinanceVendor/VendorRegistration').subscribe(res => {
      if (res.status === true) {
        this.toastr.success('Registration Created successfully');
        this.file = null;
        // this.route.navigate(['/HOME'])
        this.close();
      } else if (res.status === false) {
        this.toastr.warning(res.message);
      }
      this.deactivateSpinner();
    }, error => {
      if (error.status === 400) {
        this.toastr.error(error.error);
      } else {
        this.toastr.error('An unexpected error occurred.');
      }
      this.deactivateSpinner();
    });
  }




  close() {
    this.clearToken();
    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this.route.navigate(['/vendorlogin']);
    }, 500);
  }
  clearToken() {
    this.CommonService.postCall('Account/ClearToken', { "UserID": localStorage.getItem('UserId') }).subscribe((res: any) => {

    })
  }


  viewFile() {
    if (this.fileInput == '') {
      this.toastr.warning('File not available');
    } else {
      window.open(this.CommonService.videoUrl + this.fileInput);
    }
  }

  removeFile(typ: any) {
    this.file = null;
    this.myForm.patchValue({
      upload_proof: ""
    });
    this.fileInput = "";
  }


  onFileChangeNew(event: any, key: string) {
    this.CommonService.activateSpinner();

    const file = event.target.files[0];
    if (!file) {
      this.CommonService.deactivateSpinner();
      return;
    }

    if (file.type !== 'application/pdf') {
      this.toastr.warning('Only PDF files are allowed!');
      event.target.value = '';
      this.CommonService.deactivateSpinner();
      return;
    }

    this.uploadedFiles[key] = file;
    this.myForm.patchValue({ [key]: file.name });

    this.CommonService.deactivateSpinner();
  }

  viewFileNew(key: string) {
    if (!this.uploadedFilePaths[key]) {
      this.toastr.warning('File not available');
      return;
    }
    window.open(this.CommonService.videoUrl + this.uploadedFilePaths[key]);
  }

  removeFileNew(key: string) {
    this.uploadedFiles[key] = null;
    this.uploadedFilePaths[key] = '';
    this.myForm.patchValue({ [key]: '' });
  }



}
